// @flow
import React, { type Node } from 'react';

import styled from 'styled-components';
import { Separator } from '../../../atoms';

import { Instructions } from './instructions';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { useIncomingPayment} from '@tectonics/prs/incoming-payment';
import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { getMoneyFormat } from '@tectonics/look-and-feel/volcanes/commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';

export function CashfreeUpiCollectPage(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();

  const decimalFormat = getMoneyFormat(incomingPayment.country);
  const formatAmount = amountToCurrencyString(decimalFormat);

  return (
    <Root>
      <Body>
        <Title>Your { formatAmount(getReceiptAmountLocalTotal(receipt)) } payment was created!</Title>
        <Subtitle>
          It won&#39;t be long until your order is complete! Follow the instructions below to confirm this transaction
        </Subtitle>
        <Separator direction="vertical" size={4} />
        <Instructions />
      </Body>
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 0;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  margin-bottom: 7px;
  font-family: Gilroy, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;

`;

const Subtitle = styled.p`
  margin-bottom: 24px;
`;
